import ErrorUtil from '../../../../../util/ErrorUtil';
import UnifiedSignupScreenComponent from '../UnifiedSignupScreenComponent';
import AbstractSignupScreen from './AbstractSignupScreen';
import UnifiedSignupScreenName from '../UnifiedSignupScreenName';

export default class SignupSuccessRedirectSignupScreen extends AbstractSignupScreen {
  public readonly screenName: UnifiedSignupScreenName = 'uss-signup-success-signin-redirect';

  // eslint-disable-next-line class-methods-use-this
  public getVisibleComponents(): UnifiedSignupScreenComponent[] {
    return [];
  }

  public getValidatedComponents(): UnifiedSignupScreenComponent[] {
    return this.getVisibleComponents();
  }

  public predicate(): boolean {
    const {
      submitFormResult,
    } = this.sessionInfo.value;

    if (!submitFormResult || submitFormResult.statusCode !== 202) {
      return false;
    }

    return true;
  }

  // eslint-disable-next-line class-methods-use-this
  public async toNextScreen(): Promise <boolean> {
    return false;
  }

  public async initWatchers(): Promise<void> {
    super.initWatchers();
    this.isBackButtonHidden.value = true;
  }

  public async initListeners({ partialDiv }: { partialDiv: HTMLDivElement }): Promise<void> {
    let targetLocation = '';
    if (this.isOkEmailOrPro()) {
      targetLocation = 'https://cad.onshape.com/signin';
    }
    if (this.isOkEmailOrEdu()) {
      targetLocation = 'https://cad.onshape.com/upgrade/edu';
    }
    if (!targetLocation) {
      throw ErrorUtil.internalError({ msg: 'Redirect location is null' });
    }

    const urlElms = partialDiv.querySelectorAll('[data-redirect-url]');
    urlElms.forEach((elm) => {
      elm.setAttribute('href', targetLocation);
    });

    const countDownElms = partialDiv.querySelectorAll('[data-counter-down]');
    let numSeconds = 4;
    const interval = setInterval(() => {
      numSeconds -= 1;
      countDownElms.forEach((elm) => {
        elm.textContent = `${numSeconds}`;
        elm.setAttribute('data-counter-down', `${numSeconds}`);
      });

      if (numSeconds > 0) return; // TODO update timer
      clearInterval(interval);
      document.location = targetLocation;
    }, 1000);
  }

  // eslint-disable-next-line class-methods-use-this
  public getProgress(): number {
    return 100;
  }
}
